import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { getBusinessRelationshipWithMostAssetsUnderManagementByRequest } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useBusinessRelationshipWithMostAssetsUnderManagement(partnerUuid?: string, brUuids?: string[]): UseQueryResult<string, AxiosError> {
    return useQuery({
        queryKey: queryKeys.businessRelationshipWithMostAssetsUnderManagement(partnerUuid, brUuids),
        queryFn: ({ signal }) =>
            getBusinessRelationshipWithMostAssetsUnderManagementByRequest({ query: { partnerUuid: partnerUuid!, brUuids: brUuids! }, signal }).then(
                (result) => result.data!,
            ),
        retry: false,
        enabled: !!partnerUuid && !!brUuids,
    });
}
